/**
 * Material Taxonomy Grid Helpers
 */

import { IGetMaterialTaxonomiesVars } from './types'

/**
 * Default GraphQL variables for material taxonomies query
 * Uses standard StateEnum values: 'Unpublished' and 'Published'
 */
export const getMaterialTaxonomiesVars: IGetMaterialTaxonomiesVars = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
